// Migrated 1:1 from @nexato/nx-core-module (lib/components/note-icon.component.ts), #672.
import { Component, input, computed } from '@angular/core';

@Component({
    selector: 'app-note-icon',
    template: `
        <span class="h-[20px] -mt-[3px]" [pTooltip]="formattedNote()" [escape]="false" tooltipPosition="top">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="16" x2="12" y2="12"/>
                <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
        </span>
    `,
    styles: [`
        :host {
            display: flex;
        }
        :host([hidden]) {
            display: none !important;
        }
        svg {
            height: 14px;
            margin-top: 3px;
            margin-right: 0.125rem;
        }
    `],
    host: {
        '[attr.hidden]': 'hidden()',
        '[style.float]': 'floatLeft() ? "left" : null',
        '[style.display]': 'floatLeft() ? "flex" : "inline-flex"',
        '[style.vertical-align]': 'floatLeft() ? null : "middle"'
    }
})
export class NoteIconComponent {

    note = input<string | undefined>();
    floatLeft = input(true);

    hidden = computed(() => !this.note() ? true : null);

    /** Replaces newlines with HTML line breaks for the pTooltip with [escape]="false" */
    formattedNote = computed(() => {
        const n = this.note();
        if (!n) return undefined;
        return n.replace(/\n/g, '<br>');
    });

}
